import React from 'react'
import ReactDOM from 'react-dom'
import 'babel-polyfill'
import { unregister } from 'services/utility/common/service-worker'
import App from 'components/app'
import './assets/styles/index.scss'

ReactDOM.render(<App />, document.getElementById('root'))

unregister()



// WEBPACK FOOTER //
// ./index.js